import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from '@/locales/en/common.json';
import enHomepage from '@/locales/en/homepage.json';
import enCustomer from '@/locales/en/customer.json';
import enSeller from '@/locales/en/seller.json';
import enAdmin from '@/locales/en/admin.json';

import hiCommon from '@/locales/hi/common.json';
import hiHomepage from '@/locales/hi/homepage.json';
import hiCustomer from '@/locales/hi/customer.json';
import hiSeller from '@/locales/hi/seller.json';
import hiAdmin from '@/locales/hi/admin.json';

import mrCommon from '@/locales/mr/common.json';
import mrHomepage from '@/locales/mr/homepage.json';
import mrCustomer from '@/locales/mr/customer.json';
import mrSeller from '@/locales/mr/seller.json';
import mrAdmin from '@/locales/mr/admin.json';

import knCommon from '@/locales/kn/common.json';
import knHomepage from '@/locales/kn/homepage.json';
import knCustomer from '@/locales/kn/customer.json';
import knSeller from '@/locales/kn/seller.json';
import knAdmin from '@/locales/kn/admin.json';

import taCommon from '@/locales/ta/common.json';
import taHomepage from '@/locales/ta/homepage.json';
import taCustomer from '@/locales/ta/customer.json';
import taSeller from '@/locales/ta/seller.json';
import taAdmin from '@/locales/ta/admin.json';

import guCommon from '@/locales/gu/common.json';
import guHomepage from '@/locales/gu/homepage.json';
import guCustomer from '@/locales/gu/customer.json';
import guSeller from '@/locales/gu/seller.json';
import guAdmin from '@/locales/gu/admin.json';

import mlCommon from '@/locales/ml/common.json';
import mlHomepage from '@/locales/ml/homepage.json';
import mlCustomer from '@/locales/ml/customer.json';
import mlSeller from '@/locales/ml/seller.json';
import mlAdmin from '@/locales/ml/admin.json';

export const SUPPORTED_LANGS = [
  { code: 'en', label: 'English',   native: 'English' },
  { code: 'hi', label: 'Hindi',     native: 'हिन्दी' },
  { code: 'mr', label: 'Marathi',   native: 'मराठी' },
  { code: 'kn', label: 'Kannada',   native: 'ಕನ್ನಡ' },
  { code: 'ta', label: 'Tamil',     native: 'தமிழ்' },
  { code: 'gu', label: 'Gujarati',  native: 'ગુજરાતી' },
  { code: 'ml', label: 'Malayalam', native: 'മലയാളം' },
];

// Only ready languages are actually offered in the switcher.
export const ACTIVE_LANGS = SUPPORTED_LANGS.filter((l) => !l.comingSoon);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // `capp` and `sapp` are added at runtime by lib/i18n-capp.js and lib/i18n-sapp.js, which
    // ride along with the buyer and seller chunks — see those files.
    resources: {
      en: { common: enCommon, homepage: enHomepage, customer: enCustomer, seller: enSeller, admin: enAdmin },
      hi: { common: hiCommon, homepage: hiHomepage, customer: hiCustomer, seller: hiSeller, admin: hiAdmin },
      mr: { common: mrCommon, homepage: mrHomepage, customer: mrCustomer, seller: mrSeller, admin: mrAdmin },
      kn: { common: knCommon, homepage: knHomepage, customer: knCustomer, seller: knSeller, admin: knAdmin },
      ta: { common: taCommon, homepage: taHomepage, customer: taCustomer, seller: taSeller, admin: taAdmin },
      gu: { common: guCommon, homepage: guHomepage, customer: guCustomer, seller: guSeller, admin: guAdmin },
      ml: { common: mlCommon, homepage: mlHomepage, customer: mlCustomer, seller: mlSeller, admin: mlAdmin },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGS.map((l) => l.code),
    ns: ['common', 'homepage', 'customer', 'seller', 'admin', 'capp', 'sapp'],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'fender_lang',
      caches: ['localStorage'],
    },
    returnObjects: true,
  });

export default i18n;
